<template lang="html">
  <v-text-field
    v-model="internalValue"
    class="si-title-input ma-0"
    v-bind="$attrs"
    hide-details
    @change="save"
  />
</template>

<script>
import { rtdb } from '@/plugins/firebase'

export default {
  props: {
    value: String,
    paths: Array
  },
  data () {
    return {
      lazyValue: this.value
    }
  },
  computed: {
    // ...mapGetters([]),
    internalValue: {
      get: function () {
        return this.lazyValue
      },
      set: function (v) {
        this.lazyValue = v
        this.$emit('input', v)
      }
    }
  },
  watch: {
    value (v) {
      this.internalValue = v
    }
  },
  methods: {
    save () {
      if (!this.paths) return
      var updates = {}
      this.paths.forEach(p => {
        updates[p] = this.internalValue
      })
      rtdb.ref().update(updates)
    }
  }
}
</script>

<style lang="css" >
.si-title-input.theme--light.v-text-field > .v-input__control > .v-input__slot:before{
  border: none
}
.si-title-input.theme--light.v-text-field > .v-input__control > .v-input__slot input{
  margin-bottom:4px;
}
</style>
